import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { loadPageWithPatientIdParameter, setTheme } from '../../../../core/store/actions/app.actions';
import { selectTheme } from '../../../../core/store/selectors/app.selector';
import { FilterPipe } from '../../../pipes/filter.pipe';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import { IconComponent } from '../../icon/icon.component';
import { NavListItem } from '../models/nav-list-item';
import { getNavDispatchAction } from '../utils/nav-item.utils';

@Component({
  selector: 'app-nav-dialog',
  imports: [
    FilterPipe,
    FormsModule,
    MatDialogModule,
    IconComponent,
    IconButtonComponent,
    MatInputModule,
    MatListModule,
    MatSlideToggleModule,
    MatToolbarModule,
    ReactiveFormsModule,
    LetDirective,
  ],
  templateUrl: './nav-dialog.component.html',
  styleUrl: './nav-dialog.component.scss',
})
export class NavDialogComponent {
  private static readonly OPEN_SCHEDULE_DIALOG_ACTION_TYPE = '[Appointments] Open Schedule Appointment Dialog';
  data = inject(MAT_DIALOG_DATA);
  navList: NavListItem[] = this.data.navList?.filter((f: NavListItem) => !f.hideFromNav);
  private store = inject(Store);
  private dialogRef = inject(MatDialogRef<NavDialogComponent>);
  private router = inject(Router);
  private authService = inject(AuthService);

  subMenuMainItem: NavListItem | null = null;
  searchValue: string = '';
  isChecked: boolean = false;
  theme$ = this.store.select(selectTheme);

  setTheme = (event: MatSlideToggleChange) =>
    this.store.dispatch(setTheme({ theme: event.checked ? 'dark' : 'light' }));

  onNavigate(navListItem: NavListItem): void {
    const dispatchAction = getNavDispatchAction(navListItem);

    if (dispatchAction?.type === NavDialogComponent.OPEN_SCHEDULE_DIALOG_ACTION_TYPE) {
      this.store.dispatch(
        loadPageWithPatientIdParameter({ route: navListItem.route ?? 'appointments/schedule/provider' })
      );
    } else if (dispatchAction) {
      this.store.dispatch(dispatchAction);
    } else if (navListItem.isGuardedRoute && navListItem.route) {
      this.store.dispatch(loadPageWithPatientIdParameter({ route: navListItem.route }));
    } else if (navListItem.route) {
      this.router.navigate([navListItem.route]);
    }

    this.dialogRef.close();
  }

  onShowSubMenu(e: unknown, menuItem: NavListItem) {
    this.subMenuMainItem = menuItem;
    if (menuItem.subMenu) {
      this.navList = menuItem.subMenu;
    }
  }

  onBack() {
    this.subMenuMainItem = null;
    this.navList = this.data.navList?.filter((f: NavListItem) => !f.hideFromNav);
  }

  onLegalNavigate(event: Event, route: string): void {
    event.preventDefault();
    this.router.navigate([route]);
    this.dialogRef.close();
  }

  logout() {
    this.authService.logout();
  }
}
